import { getApi } from "./api_instance";
export const logOut = async () => {
  try {
    const { data } = await getApi({
      apiUrl: "/api/user/logout",
      sendToken: true,
      dispatch: () => {},
    });
    return data;
  } catch (error) {
    throw error;
  }
};
